module.exports = __webpack_public_path__ + "img/person-biking.cc58eb0d.svg";